import { render } from "./VehicleModelView.vue?vue&type=template&id=aee77cc6&scoped=true&ts=true"
import script from "./VehicleModelView.vue?vue&type=script&lang=ts"
export * from "./VehicleModelView.vue?vue&type=script&lang=ts"

import "./VehicleModelView.vue?vue&type=style&index=0&id=aee77cc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee77cc6"]])

export default __exports__